import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_INVOICES } from 'dealer-reducers'
import { RootReducer } from '../../redux/rootReducer'
import Layout from '../layout/Layout'
import { useTranslation } from 'react-i18next'
import InvoiceSvg from '../other/svg/InvoiceSvg'
import { ListInvoice } from 'dealer-types'
import FlatList from '../molecules/FlatList'
import InvoiceItemWrapper from './InvoiceItemWrapper'

const Invoices = (): JSX.Element => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const { invoices } = useSelector((state: RootReducer) => state.invoicesListReducer)

  useEffect(() => {
    dispatch(FETCH_INVOICES({}))
  }, [dispatch])

  return (
    <Layout
      withoutToolbar={false}
      iconComponent={<InvoiceSvg className="w-8 h-8 text-white" />}
      withFiler={false}
      name={t('invoices')}>
      <div className="h-[calc(100vh-200px)]">
        <FlatList
          data={invoices}
          component={(itemProps: ListInvoice) => <InvoiceItemWrapper {...itemProps} />}
          // eslint-disable-next-line require-await
          fetchMore={async () => {
            dispatch(FETCH_INVOICES({}))
            // eslint-disable-next-line @typescript-eslint/return-await
            return Promise.resolve()
          }}
          itemMinWidth={'100%'}
        />
      </div>
    </Layout>
  )
}

export default Invoices
